import { Paper, Box, SvgIcon, Typography, Button } from "@mui/material";
import { NoteAddOutlined as NoteAddOutlinedIcon } from "@mui/icons-material";

const PaperRedirectVid = ({ videoUrl }) => {
  return (
    <Paper
      sx={{
        mb: { xs: 5 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "start",
        height: "200px",
        borderRadius: 5,
        p: 4,
        color: "#FFFFFF",
        backgroundImage: `url(/bg-ordenes.png)`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        "&:hover": {
          boxShadow: 1,
          backgroundImage: `linear-gradient(#00000010, #00000010), url(/bg-ordenes.png)`,
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "start" }}>
        <SvgIcon color="white" sx={{ fontSize: 40, ml: -1, mr: 1 }}>
          <NoteAddOutlinedIcon />
        </SvgIcon>
        <Typography color="white" sx={{ fontSize: "20px", fontWeight: 600 }}>
          Como puedo crear nuevas Plantillas?
        </Typography>
      </Box>

      <Typography color="white" sx={{ fontSize: "14px" }}>
        Para más información, puede consultar el siguiente
        <div>
          <strong>video instructivo</strong>
        </div>
      </Typography>
      <Button
        variant="customWhite"
        onClick={() => window.open(videoUrl, "_blank", "noopener,noreferrer")}
      >
        Ver video ahora
      </Button>
    </Paper>
  );
};

export default PaperRedirectVid;
